/** @format — Pill badge for port recommendation cards */

import React from "react";
import { Trophy, MapPin, CircleDollarSign, Tag } from "lucide-react";
import { PORT_BADGE_THEMES } from "./portBadgeUtils";

const BADGE_ICONS = {
  best_choice: Trophy,
  closest_port: MapPin,
  cheapest: CircleDollarSign,
  earliest_sailing: Tag,
};

export default function PortBadge({ badgeId, className = "" }) {
  const theme = PORT_BADGE_THEMES[badgeId];
  if (!theme) return null;

  const Icon = BADGE_ICONS[badgeId] ?? Tag;

  return (
    <div
      className={`inline-flex items-center justify-center gap-1 px-2 py-0.5 rounded-full border border-neutral-200 w-fit max-w-full shrink-0 ${theme.badgeBg} ${className}`}
    >
      <Icon
        className={`w-3 h-3 flex-shrink-0 ${theme.badgeText}`}
        strokeWidth={1.5}
        aria-hidden
      />
      <span className={`text-xs font-medium leading-none whitespace-nowrap ${theme.badgeText}`}>
        {theme.label}
      </span>
    </div>
  );
}
